@if (availablePacks) {
  <pr-swiper
    swiperMinWidth="0"
    [config]="config"
    [index]="selectedPack?.index - 2 || 0"
  >
    @for (pack of availablePacks; track pack; let i = $index) {
      <pr-slide>
        <simulation-pack
          [pack]="pack"
          [color]="utils.getAppColor(i)"
          (click)="selectPack(pack)"
          [ngClass]="{ active: selectedPack && pack.id === selectedPack.id }"
          (onEdit)="triggerForm()"
          [withCustomPack]="withCustomPack"
          [withPanelTitle]="withPanelTitle"
          [suitableBaseOnScore]="suitableBaseOnScore"
        >
          {{ pack | json }}
        </simulation-pack>
      </pr-slide>
    }
  </pr-swiper>
}
